import React, { useEffect, useRef } from 'react';
import './Hero.scss';
import { gsap } from 'gsap';
import contents from '../../contents';
import logoImg from '../../assets/logo.svg';
import videoLoopD from '../../assets/hero_desktop.mp4';
import videoLoopM from '../../assets/hero_mobile.mp4';

function Hero({ handleMouseLeaveTooltip, handleMouseEnterTooltip, width }) {
  const logoTooltip = useRef();
  const videoLoopRef = useRef();

  useEffect(() => {
    gsap.fromTo('#logo', { opacity: 0 }, { opacity: 1, duration: 0.7, delay: 0.5 });
    gsap.fromTo('#title', { opacity: 0 }, { opacity: 1, duration: 0.7, delay: 0.8 });
  }, []);

  useEffect(() => {
    videoLoopRef.current.play();
  }, []);

  return (
    <section className="hero">
      <div className="hero__overlay" />

      <div className="hero__videoLoop-container">
        <video autoPlay muted playsInline loop className="hero__videoLoop-video" ref={videoLoopRef}>
          <source media="(min-width:376px)" src={videoLoopD} type="video/mp4" />
          <source media="(max-width:375px)" src={videoLoopM} type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>
      </div>

      <div className="hero__logo-container hero__logo-container--top" id="logo">
        <a href={contents.logoTooltip.href} target="_blank" rel="sponsored noopener">
          <img
            className="hero__logo-logo"
            src={logoImg}
            alt="logo"
            onMouseEnter={(e) => {
              handleMouseEnterTooltip(e, logoTooltip);
            }}
            onMouseLeave={() => {
              handleMouseLeaveTooltip(logoTooltip);
            }}
          />
        </a>
        <div className="tooltip" ref={logoTooltip}>
          <p className="tooltip-content">Visit {contents.logoTooltip.copy}</p>
        </div>
      </div>

      <div className="hero__contents">
        <div className="hero__titleBox">
          {width > 767 ? (
            <h1 className="hero__titleBox-title" id="title">
              Breaking the <span className="carT">CAR T</span>
              <br />
              Access Bottleneck for
              <br />
              Patients with Cancer
            </h1>
          ) : (
            <h1 className="hero__titleBox-title" id="title">
              Breaking the
              <br />
              CAR T Access
              <br />
              Bottleneck for
              <br />
              Patients with
              <br />
              Cancer
            </h1>
          )}
        </div>
      </div>
    </section>
  );
}

export default Hero;
